// app/(app)/reports/_layout.tsx
import { useAppTheme } from "@/hooks/useAppTheme";
import { Stack } from "expo-router";

export default function ReportsLayout() {
  const { colors } = useAppTheme();

  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: colors.background },
        headerTintColor: colors.text,
        headerShadowVisible: false,
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen
        name="index"
        options={{ title: "Sales Report", headerShown: true }}
      />
      <Stack.Screen
        name="product-requirement"
        options={{ title: "Product Requirement", headerShown: true }}
      />
    </Stack>
  );
}
